import React from "react";

interface CharityCampaignMarkProps {
  className?: string;
}

/**
 * Route Home — the Ride to Rebuild campaign mark.
 * A ride trace that runs along and then lifts into a rooftop ridge, so the
 * journey and the thing it pays for are one gesture. Drawn for the campaign's
 * dark header without a plate: the trace takes the surrounding ink through
 * `currentColor` and only the ridge carries the campaign orange.
 *
 * The viewBox is cropped to the artwork rather than a square, so the mark fills
 * the height it is given. A square box would letterbox it to half that, putting
 * the strokes under two pixels at header size.
 *
 * @param className - Sizing and layout classes for the SVG element
 * @returns The campaign mark, named for assistive technology
 */
export const CharityCampaignMark: React.FC<CharityCampaignMarkProps> = ({ className = "h-[28px] w-[43px]" }) => (
  <svg viewBox="0 16 64 42" role="img" aria-label="Ride to Rebuild" className={`flex-shrink-0 ${className}`}>
    <path
      d="M5 51 L15 45 L24 50 L34 46"
      fill="none"
      stroke="currentColor"
      strokeWidth="4.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M34 46 L47 23 L60 46"
      fill="none"
      stroke="#E66E1A"
      strokeWidth="5.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="5" cy="51" r="3.4" fill="currentColor" />
  </svg>
);
